const initialState = {
    activeForm: 'registration',
    clientId: null,
};

export default initialState;
